<template lang="html">
  <div v-if="hasNews" class="note">
    <h2 v-if="siteSettings.news_title">{{ siteSettings.news_title }}</h2>
    <p v-if="siteSettings.news_text">{{ siteSettings.news_text }}</p>

    <button
      v-if="siteSettings.news_link"
      class="l"
      @click="openLink"
    >
      {{ linkTitle }}
    </button>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ElNewsNote",
  computed: {
    ...mapGetters(["siteSettings"]),
    hasNews() {
      if (!this.siteSettings) return false;
      return !!(
        this.siteSettings.news_title?.trim() ||
        this.siteSettings.news_text?.trim()
      );
    },
    linkTitle() {
      const title = this.siteSettings?.news_link_title?.trim();
      return title || "More Information";
    },
  },
  methods: {
    openLink() {
      const link = this.siteSettings?.news_link?.trim();
      if (!link) return;

      if (link.startsWith("http://") || link.startsWith("https://")) {
        window.open(link, "_blank").focus();
        return;
      }

      const path = link.startsWith("/") ? link : `/${link}`;
      if (this.$route.path === path) {
        this.scrollDown();
      } else {
        this.$router.push({ path });
      }
    },
    scrollDown() {
      let newPos;
      if (window.innerWidth > 600) {
        newPos = window.innerHeight - 30;
      } else {
        newPos = window.innerHeight;
      }
      window.scrollTo({
        top: newPos,
        left: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style lang="css" scoped>
/* Uses global .note styles from main.css */
</style>
